import { NavLink } from 'react-router-dom';

import { IAdminActionedRecordDetails } from './AdminActionedRecordDetails.types';

import InfoNewIcon from '../../svgs/InfoNewIcon';
import CloseIcon from '../../svgs/CloseIcon';

import styles from './AdminActionedRecordDetails.module.scss';

const AdminActionedRecordDetails = ({
  lastName, firstName, action, recordTitle, routePath, tableTitle, onClose, recordName,
}: IAdminActionedRecordDetails) => {
  const fullName = `${lastName} ${firstName}`;
  return (
    <div className={styles?.wrapper}>
      <div className={styles?.wrapper__close} onClick={onClose}>
        <CloseIcon />
      </div>
      <div className={styles?.wrapper__content}>
        <InfoNewIcon />
        <div>
          <h5 className={styles?.wrapper__headText}>{recordName}</h5>
          <p className={styles?.wrapper__subText}>
            {`This ${recordTitle} was ${action} by `}
            <span
              className={styles?.wrapper__subTextStyled}
            >
              {fullName}
            </span>
          </p>
          <NavLink to={routePath} className={styles.wrapper__hyperLink}>
            <h6 className={styles.wrapper__hyperLinkText}>{`View ${tableTitle} Table`}</h6>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default AdminActionedRecordDetails;
